import React from "react";
import { useParams } from "react-router-dom";
import CatalogListing from "../components/CatalogListing";
import { FILM_CATEGORIES } from "../constants/catalog";

export default function WindowFilmCategory() {
    const { slug } = useParams();
    const category = FILM_CATEGORIES.find((c) => c.slug === slug)
        || { slug, name: "Window Film", desc: "" };
    return (
        <div data-testid={`film-category-page-${slug}`}>
            <CatalogListing topCategory="film" topLabel="Automotive Window Film" topPath="/automotive-window-film" category={category} />
        </div>
    );
}
